import React from 'react';

export const BY = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5593)'>
				<mask
					id='mask0_11534_5593'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5593)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20V15H0V0Z'
						fill='#73BE4A'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V10H20V0H0Z'
						fill='#AF0100'
					/>
					<rect width='3.75' height='15' fill='#F7FCFF' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0.624971 0C0.970176 0 1.24997 0.279844 1.24997 0.625012C1.24997 0.970181 0.970176 1.25003 0.624971 1.25003C0.279845 1.25003 -1.52588e-05 0.970181 -1.52588e-05 0.625012C-1.52588e-05 0.279844 0.279845 0 0.624971 0ZM3.12502 0C3.47015 0 3.75001 0.279844 3.75001 0.625012C3.75001 0.970181 3.47015 1.25003 3.12502 1.25003C2.77982 1.25003 2.50003 0.970181 2.50003 0.625012C2.50003 0.279844 2.77982 0 3.12502 0ZM1.24997 3.12502C1.24997 2.7798 0.970176 2.50001 0.624971 2.50001C0.279845 2.50001 -1.52588e-05 2.7798 -1.52588e-05 3.12502C-1.52588e-05 3.47019 0.279845 3.74998 0.624971 3.74998C0.970176 3.74998 1.24997 3.47019 1.24997 3.12502ZM3.12502 2.50001C3.47015 2.50001 3.75001 2.7798 3.75001 3.12502C3.75001 3.47019 3.47015 3.74998 3.12502 3.74998C2.77982 3.74998 2.50003 3.47019 2.50003 3.12502C2.50003 2.7798 2.77982 2.50001 3.12502 2.50001ZM3.12502 11.25C3.47015 11.25 3.75001 11.5298 3.75001 11.875C3.75001 12.2202 3.47015 12.5 3.12502 12.5C2.77982 12.5 2.50003 12.2202 2.50003 11.875C2.50003 11.5298 2.77982 11.25 3.12502 11.25ZM1.24997 11.875C1.24997 11.5298 0.970176 11.25 0.624971 11.25C0.279845 11.25 -1.52588e-05 11.5298 -1.52588e-05 11.875C-1.52588e-05 12.2202 0.279845 12.5 0.624971 12.5C0.970176 12.5 1.24997 12.2202 1.24997 11.875ZM0.624971 13.75C0.970176 13.75 1.24997 14.0298 1.24997 14.375C1.24997 14.7202 0.970176 15 0.624971 15C0.279845 15 -1.52588e-05 14.7202 -1.52588e-05 14.375C-1.52588e-05 14.0298 0.279845 13.75 0.624971 13.75ZM3.75001 14.375C3.75001 14.0298 3.47015 13.75 3.12502 13.75C2.77982 13.75 2.50003 14.0298 2.50003 14.375C2.50003 14.7202 2.77982 15 3.12502 15C3.47015 15 3.75001 14.7202 3.75001 14.375ZM1.87495 12.5C2.22016 12.5 2.50003 12.7798 2.50003 13.125C2.50003 13.4702 2.22016 13.75 1.87495 13.75C1.52983 13.75 1.24997 13.4702 1.24997 13.125C1.24997 12.7798 1.52983 12.5 1.87495 12.5ZM2.50003 1.875C2.50003 1.52983 2.22016 1.25003 1.87495 1.25003C1.52983 1.25003 1.24997 1.52983 1.24997 1.875C1.24997 2.22017 1.52983 2.50001 1.87495 2.50001C2.22016 2.50001 2.50003 2.22017 2.50003 1.875ZM2.56872 7.52419L3.75001 8.75001V9.99998L3.77735 10.058L1.93192 8.21109L0.273519 9.99998H0.000142097V8.75001L1.23909 7.5177L0.000142097 6.27774V5.00002H0.136266L1.9148 6.84561L3.70199 5.06799L3.75001 5.00002V6.24996L2.56872 7.52419ZM1.87495 3.74998C2.22016 3.74998 2.50003 4.02984 2.50003 4.37499C2.50003 4.72016 2.22016 5.00002 1.87495 5.00002C1.52983 5.00002 1.24997 4.72016 1.24997 4.37499C1.24997 4.02984 1.52983 3.74998 1.87495 3.74998ZM2.50003 10.625C2.50003 10.2798 2.22016 9.99998 1.87495 9.99998C1.52983 9.99998 1.24997 10.2798 1.24997 10.625C1.24997 10.9702 1.52983 11.25 1.87495 11.25C2.22016 11.25 2.50003 10.9702 2.50003 10.625Z'
						fill='#D0181A'
					/>
					<path
						opacity='0.4'
						fillRule='evenodd'
						clipRule='evenodd'
						d='M-1.52588e-05 0H1.24997V1.25003H-1.52588e-05V0ZM1.24997 2.50001H-1.52588e-05V3.74998H1.24997V2.50001ZM-1.52588e-05 5.00002H1.24997V6.24999H-1.52588e-05V5.00002ZM1.24997 8.75001H-1.52588e-05V9.99998H1.24997V8.75001ZM-1.52588e-05 11.25H1.24997V12.5H-1.52588e-05V11.25ZM1.24997 13.75H-1.52588e-05V15H1.24997V13.75ZM3.75001 13.75H2.50003V15H3.75001V13.75ZM3.75001 0H2.50003V1.25003H3.75001V0Z'
						fill='#8F181A'
					/>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5593'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
